export default {
  ADD_TOAST_NOTIFICATIONS: '@@toast-notification/ADD_TOAST_NOTIFICATIONS',
  REMOVE_TOAST_NOTIFICATIONS: '@@toast-notification/REMOVE_TOAST_NOTIFICATIONS',
};
